import * as m from "mithril";
import AppContext from "../../context/AppContext";
import { NavBar } from '../../components/NavBar';
import { OperatorDTO } from "../../apiclient/ApiDtos";
import LoadingIndicator from "../../components/LoadingIndicator";
import buildLanguageChangeActions from "../common/LanguageNavActions";
import { getIntlStringValue } from "../../helpers/StringHelpers";

interface Attrs{
    appContext: AppContext,
    operator: OperatorDTO,
    data: 'fetching' | string[],
    onBackPressed: () => void,
}

function OperatorInfoPage(): m.Component<Attrs> {
    return {        
        view(vnode) {
            let operator = vnode.attrs.operator;
            let photoUrls = vnode.attrs.data == 'fetching'? [] : vnode.attrs.data;
            console.log("Photo urls", photoUrls);

            let messageProvider = vnode.attrs.appContext.getMessageProvider();
            let lang = messageProvider.getCurrentLang();

            let langChangeActionItems = buildLanguageChangeActions(vnode.attrs.appContext);

            return m('div', { class: "app-layout" },
                [
                    m(NavBar, {
                        title: getIntlStringValue(operator.name, lang),
                        canBackPress: true,
                        onBackPressed: () => vnode.attrs.onBackPressed(),
                        actionItems: langChangeActionItems,
                    }),

                    (vnode.attrs.data == 'fetching') ?
                    m(LoadingIndicator) : 
                    m("div.app-area-main", 
                        (vnode.attrs.data.length > 0)?
                        photoUrls.map(function (photoUrl) {
                            return m("div", { class: "mt-2" },
                                m("img", {
                                    class:"img-fluid w-100",
                                    src: photoUrl,
                                })
                            )
                        }):
                        m("div.text-center p-5 text-muted", 
                            vnode.attrs.appContext.getMessageProvider().get("operator.photos_unavailable")
                        )
                    
                    )
                ]);
        }
    }
};

export default OperatorInfoPage;